const { helpers } = require("../utils");
const isTest = 1;

export const fmk = helpers.text.format.k;
export const fmn = helpers.text.format.number;
export const fmc = helpers.text.format.currency;
export const is = helpers.html.is;
export const getCookie = helpers.html.getCookie;
export const setCookie = helpers.html.setCookie;
export const tufl = helpers.text.to.upper.firstLetter;
export const tuflow = helpers.text.to.upper.firstLetterOfWord;
export const validate = helpers.text.validate;
export const hmap = helpers.html.map;
export const hwait = helpers.html.wait;
export const hlog = helpers.html.log;
export const hdownload = helpers.html.download;
export const hrf = helpers.html.readFile;
export const tgh = helpers.text.getHost;
export const cpo = helpers.text.cpo;
export const tRemove = helpers.text.remove;
export const tRandom = helpers.text.random;
export const tLink = helpers.text.link;
export const tBase64 = helpers.text.base64;
export const tMap = helpers.text.map;

const extensionId = isTest ? "fdikogjhbfniokcnlmlfoncdcgclebnc" : "mlelchagioenlbidcanfaefadgmoinaj";
export const extension = {
    chrome: {
        id: extensionId,
        href: `https://chrome.google.com/webstore/detail/isaura-chrome-extension/${extensionId}?hl=vi`,
        require: {
            version: "1.1.1",
        },
    },
};


// WEBPACK FOOTER //
// src/plugins/filters.js